// used as word-join indicator in edit ops
export const ZERO_WIDTH_WS = String.fromCodePoint(8203);
// u'\u00AD'
export const SOFT_HYPHEN = String.fromCodePoint(173);
export const HYPHEN = '¬';
export const NEW_LINE_TEXT = '[LINE]';
export const NEW_WORD_TEXT = '[WORD]';
export const APPEND_AS_LAST_LINE = null;
export const DELETED_WORD = '';
export const PILCROW = String.fromCodePoint(0x00b6);
